import type { PrivacyStrings } from "../../types";

export const mobilePrivacy: PrivacyStrings = {
  "title": "Cate Mobile privacy",
  "lastUpdated": "Last updated: 3 November 2026",
  "sections": [
    {
      "title": "About this supplement",
      "paragraphs": [
        {
          "nodes": [
            "This supplement covers the Cate Mobile app for iPhone. Read it together with the main Cate privacy policy, which identifies our controller and contact, explains Cate Connect and external AI providers, and sets out your privacy rights. Visiting this page is covered by the website section of that policy."
          ]
        },
        {
          "nodes": [
            {
              "link": "Cate privacy policy",
              "href": "/privacy"
            }
          ]
        }
      ]
    },
    {
      "title": "On your device",
      "paragraphs": [
        {
          "nodes": [
            "Cate Mobile stores paired workspace records and app settings on your device, and device and notification secrets in the iOS Keychain. Workspace files and sessions remain on the runtime computer; the app receives the content needed to display and control the workspace over the encrypted connection described in the main policy. Use Forget to remove a workspace’s local pairing record. This does not delete workspace files or revoke the device’s access on the computer; manage paired devices there to revoke access. Removing the app does not necessarily erase Keychain entries."
          ]
        }
      ]
    },
    {
      "title": "Optional push notifications",
      "paragraphs": [
        {
          "nodes": [
            "If you allow notifications, Apple issues a push token. The paired runtime stores the token and the key used to encrypt notifications for your device. Cate Connect forwards the token and encrypted payload to Apple Push Notification service without persisting push tokens in its application store. The notification extension decrypts the payload on your device using its Keychain key. Apple processes delivery information under its own privacy policy. Disable notifications in iOS Settings and manage paired-device access in Cate on your computer."
          ]
        },
        {
          "nodes": [
            {
              "link": "Apple privacy policy",
              "href": "https://www.apple.com/legal/privacy/"
            }
          ]
        }
      ]
    },
    {
      "title": "Purpose and choices",
      "paragraphs": [
        {
          "nodes": [
            "We process pairing and notification information to provide the features you request (Art. 6(1)(b) GDPR). Notifications also require your iOS permission. Cate Mobile does not include advertising or third-party analytics SDKs. The desktop crash reporting and usage analytics described in the main policy apply to the desktop app."
          ]
        }
      ]
    },
    {
      "title": "Contact and your rights",
      "paragraphs": [
        {
          "nodes": [
            "For the controller’s address, contact details, GDPR rights and supervisory authority, see the main Cate privacy policy. When asking about connection records, include the relevant runtime identifier, but do not send private pairing keys or workspace content."
          ]
        },
        {
          "nodes": [
            {
              "link": "Cate privacy policy",
              "href": "/privacy"
            }
          ]
        }
      ]
    }
  ]
};
